module.exports = __webpack_public_path__ + "media/markers/unmarked_red-25350abe.png";